import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { App } from '@capacitor/app';

import { AppService } from './app.service';
import { CategoriesService } from './categories/categories.service';

import { Category } from '@models/category.model';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  categories: Category[];

  constructor(
    private zone: NgZone,
    private router: Router,
    private _categories: CategoriesService,
    public menuCtrl: MenuController,
    public app: AppService
  ) {
    this.interceptDeepLinks();
  }
  async ngOnInit(): Promise<void> {
    this.categories = await this._categories.getListOfMenuItems();
  }
  private interceptDeepLinks(): void {
    App.addListener('appUrlOpen', ({ url }) => {
      this.zone.run(() => {
        const slug = new URL(url).pathname;
        if (slug && slug !== '/') {
          this.app.fromDeepLink = true;
          this.router.navigateByUrl(slug);
        }
      });
    });
  }

  async goTo(path: string[]): Promise<void> {
    await this.menuCtrl.close();
    this.app.goTo(path, { root: true });
  }

  handleMenuClick(category: Category): void {
    category.url ? this.app.openURL(category.url) : this.app.goTo(category.navigationPath);
    this.menuCtrl.close();
  }
}
